import {
  CustomAppBody,
  MobileStepperWrapper,
  Step,
  StepContent,
  StepDescription,
  StepLine,
  StepNumber,
  StepperContainer,
  StepperHeader,
  StepperWrapper,
  StepTitle,
} from 'pages/AddLiquidity/styled'
import React from 'react'
import { steps } from '../../steps'

interface StepsProps {
  activeStep: number
  step0Validate: boolean
  step1Validate: boolean
  handleStep: (step: number) => void
}

const Steps: React.FC<StepsProps> = ({ activeStep, step0Validate, step1Validate, handleStep }) => {
  return (
    <>
      <StepperWrapper>
        <CustomAppBody width="100%">
          <StepperHeader>
            <h2>New Concentrated Liquidity Position</h2>
          </StepperHeader>
          <StepperContainer>
            {steps.map((step, index) => (
              <Step
                key={index}
                clickable={!!(index < activeStep || (index === 1 && step0Validate) || (index === 2 && step1Validate))}
                onClick={() => handleStep(index)}
              >
                <StepNumber active={index === activeStep}>{index + 1}</StepNumber>
                {index < steps.length - 1 && <StepLine />}
                <StepContent>
                  <StepTitle active={index === activeStep}>{step.title}</StepTitle>
                  <StepDescription active={index === activeStep}>{step.description}</StepDescription>
                </StepContent>
              </Step>
            ))}
          </StepperContainer>
        </CustomAppBody>
      </StepperWrapper>
      <MobileStepperWrapper>
        <CustomAppBody width="100%">
          <StepperContainer>
            <Step
              key={activeStep}
              clickable={
                !!(
                  activeStep < activeStep ||
                  (activeStep === 1 && step0Validate) ||
                  (activeStep === 2 && step1Validate)
                )
              }
              onClick={() => handleStep(activeStep)}
            >
              <StepNumber active={activeStep === activeStep}>{activeStep + 1}</StepNumber>
              <StepContent>
                <StepTitle active={activeStep === activeStep}>{steps[activeStep].title}</StepTitle>
                <StepDescription active={activeStep === activeStep}>{steps[activeStep].description}</StepDescription>
              </StepContent>
            </Step>
          </StepperContainer>
        </CustomAppBody>
      </MobileStepperWrapper>
    </>
  )
}
export default React.memo(Steps)
